let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e8jpx")).then(() => parcelRequire('2wn0H'));